import { faHeartPulse } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';

import CreateHealthieAccount from '@/pages/Profile/components/OutlinksSection/components/CreateHealthieAccount';
import { Button } from '@/ui/Button';
import Tooltip from '@/ui/components/Tooltip';

import { Props } from './types';

const CreateHealthieAccountButton = ({ person }: Props) => {
  const [isCreatingHealthieAccount, setisCreatingHealthieAccount] = useState(false);
  const { attributes_missing_for_healthie, healthie_id, id: personId } = person;

  if (healthie_id) {
    return null;
  }

  const buttontext = 'Create a Healthie Account';

  if (attributes_missing_for_healthie.length) {
    return (
      <div className="inline-flex">
        <Tooltip
          tooltipContent={
            <div>
              Missing attributes required:
              <ul>
                {attributes_missing_for_healthie.map((attribute) => (
                  <li key={attribute}>{attribute}</li>
                ))}
              </ul>
            </div>
          }>
          <Button
            color="secondary"
            disabled
            leftIcon={faHeartPulse}
            className="px-3 pointer-coarse:h-11"
            size="md"
            variant="subtle">
            {buttontext}
          </Button>
        </Tooltip>
      </div>
    );
  }

  return (
    <>
      <Button
        color="secondary"
        disabled={isCreatingHealthieAccount}
        leftIcon={faHeartPulse}
        onClick={() => setisCreatingHealthieAccount(true)}
        className="px-3 pointer-coarse:h-11"
        size="md"
        variant="subtle">
        {buttontext}
      </Button>

      {isCreatingHealthieAccount && (
        <div className="basis-full">
          <CreateHealthieAccount
            onError={() => setisCreatingHealthieAccount(false)}
            onSuccess={() => setisCreatingHealthieAccount(false)}
            personId={personId}
          />
        </div>
      )}
    </>
  );
};

export default CreateHealthieAccountButton;
